<template>
  <article>
    <span>
      <v-tooltip top :close-delay="500" allow-overflow >
        <v-chip
          slot="activator"
          small
          color="grey darken-1"
          text-color="white"
          @click.native="openTabelaLei()"
          v-if="item.item && item.item.lei && item.item.lei.descricao && item.item.lei.descricao.length >= 15">
          {{item.item.lei.descricao.substr(0,15) + "..."}}
          </v-chip>
        <v-chip
          slot="activator"
          small
          color="grey darken-1"
          text-color="white"
          @click.native="openTabelaLei()"
          v-else>
          {{item.item.lei.descricao}}
          </v-chip>
        <span>Visualizar descrição da lei</span>
      </v-tooltip>
    </span>
    <v-dialog @keydown.esc="openDialog = false" v-model="openDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span>
            <strong>LEI 116</strong>
          </span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="openDialog=false">
            <v-icon color="red">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <table border="1" class="table_lei">
                  <thead>
                    <tr>
                      <th colspan="1" style="padding: 5px;">Código</th>
                      <th colspan="2">Descrição</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-xs-center">{{item.item.lei.codigo}}</td>
                      <td class="text-xs-center">{{item.item.lei.descricao}}</td>
                     
                    </tr>
                  </tbody>
                </table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </article>
</template>
<script>
export default {
  props: ["item"],
  beforeMount() {},
  data: () => ({
    openDialog: false,
  }),
  methods: {
    openTabelaLei: function() {
      this.openDialog = true;
    },
  },
};
</script>
<style>
.table_lei {
  border-collapse: collapse;
  width: 100%;
  overflow: hidden;
    text-overflow: ellipsis;
}
.table_lei td,
.table_lei th {
  border: 1px solid black;
}
.table_lei td {
  padding: 0px 5px;
}

.destaque_fundo {
  background-color: #00808096;
}
</style>
  



// WEBPACK FOOTER //
// src/components/dataTable/commonTable/coluna_lei116/Coluna_lei.vue